import React, { FunctionComponent, ReactText } from 'react';

import PrimaryInput from '@components/library/inputs/PrimaryInput';
import { CustomFieldKeyValuesEntry, CustomFieldPayloadOperations } from '@components/asset/modal/tabs/edit/EditTabTypes';

interface SingleValueFreeEntryProps {
  customFieldKeyId: string;
  dispatchCustomFieldValue: (
    optionValue: ReactText,
    operation: CustomFieldPayloadOperations,
    customFieldValueId?: string
  ) => void;
  existingCustomFieldMap: CustomFieldKeyValuesEntry;}

export const SingleValueFreeEntry: FunctionComponent<SingleValueFreeEntryProps> = ({
  customFieldKeyId,
  dispatchCustomFieldValue,
  existingCustomFieldMap
}) => {
  const inputValue = existingCustomFieldMap?.customFieldValues.length > 0
    ? existingCustomFieldMap?.customFieldValues[0].value
    : '';

  return (
    <PrimaryInput
      attributes={{
        'aria-label': "custom field value",
        className: "custom-field-primary-input",
        name: `custom-field-value-input--${customFieldKeyId}`,
        placeholder: bfTranslate("Input value"),
        value: inputValue,
        onChange: (e): void => {
          let op = CustomFieldPayloadOperations.Update;
          const customFieldValueId = existingCustomFieldMap?.customFieldValues.length > 0
            && existingCustomFieldMap?.customFieldValues[0].key;
          if (!existingCustomFieldMap || existingCustomFieldMap.customFieldValues.length === 0) {
            op = CustomFieldPayloadOperations.Create;
          }
          dispatchCustomFieldValue((e as InputChangeEvent).target.value, op, customFieldValueId || '');
        }
      }}
      input={{ value: inputValue }}
    />
  );
};
